import { useMutation, useQueryClient } from '@tanstack/react-query';
import { datasetApi, getDatasetRequestConfig } from '../api';
import { OPERATIONS_QUERY } from './useOperations';

export const useDeleteDataset = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [
      '@MDH',
      'deleteDatasetApiV1DatasetDatasetNameDelete',
    ] as const,
    mutationFn: async ({ datasetName }: { datasetName: string }) => {
      return datasetApi.deleteDatasetApiV2DatasetsDatasetNameDelete(
        datasetName,
        getDatasetRequestConfig()
      );
    },
    // Not awaited, so the caller's callbacks run before the refetched delete
    // takes the page away.
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: OPERATIONS_QUERY });
    },
  });
};
